import { combineReducers } from 'redux';

import { dataFetchReducer } from './dataFetchReducer';
export default combineReducers({
    dataFetchReducer,
});
